<template>
	<div class="preloader">
		<div
			ref="lottieContainer"
			class="animation"
		></div>
	</div>
</template>

<script setup lang="ts">
	import { onMounted, ref } from 'vue';
	import lottie from 'lottie-web';
	import AnimationCarJson from '~/assets/image/Loading_car.json';

	const lottieContainer = ref<HTMLElement | null>(null);

	onMounted(async () => {
		if (!lottieContainer.value) return;

		lottie.loadAnimation({
			container: lottieContainer.value,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			// path: '/Loading_car.json'
			animationData: AnimationCarJson
		});
	});
</script>

<style scoped lang="scss">
	.preloader {
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.animation {
		width: 200px;
		height: 200px;
	}
</style>
